<div class="mb-5">
	<h1 class="h3 m-4">{{'utilization.percent_battery_utilization_scores' | translate}} <app-help-tooltip [field]="'battlinkDevice.utilization_scores'"></app-help-tooltip></h1>
	<div class="chart-container" *ngIf="!noData; else noDataToShow">
		<div class="filter-container">
			<!-- period filter -->
			<div class="col-sm-6 col-md-3 col-lg-3" *ngIf="!userParentFilters">
				<label for="periodSelect">{{"rt_history.periods" | translate}}</label>
				<ng-select
					class="select"
					[items]="periods"
					[addTag]="false"
					[clearable]="false"
					[searchable]="false"
					bindLabel="label"
					bindValue="value"
					(change)="onSelectionChanged({filter: 'period', value: $event.value})"
					[placeholder]="'g.durations' | translate"
					[(ngModel)]="selectedPeriod"
				></ng-select>
			</div>

			 <!-- voltage filter -->
			<div class="col-sm-6 col-md-3 col-lg-3" *ngIf="!userParentFilters">
				<label for="batteryVoltageSelect">{{"fleet_reports.battery_voltage" | translate}}</label>
				<ng-select
					id="batteryVoltageSelect"
					class="select"
					[items]="batteryVoltagesOptions"
					[addTag]="false"
					[clearable]="false"
					[searchable]="false"
					bindLabel="label"
					bindValue="value"
					(change)="onSelectionChanged({filter: 'voltageFilter', value: $event.value})"
					[placeholder]="'qv.voltage' | translate"
					[(ngModel)]="selectedBatteryVoltage"
				></ng-select>
			</div>

			<!-- capacity filter -->
			<div class="col-sm-6 col-md-3 col-lg-3" *ngIf="!userParentFilters">
				<label for="batteryCapacitySelect">{{"devices.battery_capacity" | translate}}</label>
				<ng-select
					id="batteryCapacitySelect"
					class="select"
					[items]="batteryCapacitiesOptions"
					[addTag]="false"
					[clearable]="false"
					[searchable]="false"
					bindLabel="label"
					bindValue="value"
					(change)="onSelectionChanged({filter: 'capacityFilter', value: $event.value})"
					[placeholder]="'qv.capacity' | translate"
					[(ngModel)]="selectedBatteryCapacity"
				></ng-select>
			</div>

		</div>
		<div class="charts-row">
			<sct-charts
				[type]="'BarChart'"
				[title]="'utilization.percent_utilization_score' | translate"
				[columnNames]="columnNames"
				[data]="utilizationChartData"
				[options]="barChartOptions"
				(select)="onBarSelect($event, rangesUtilization, utilizationScoreSelectedData, 'utilization.percent_utilization_score')">
			</sct-charts>
			<sct-charts
				[type]="'BarChart'"
				[title]="'utilization.percent_energy_usage_score' | translate"
				[columnNames]="columnNames"
				[data]="energyChartData"
				[options]="barChartOptions"
				(select)="onBarSelect($event, rangesEnergy, energyScoreSelectedData, 'utilization.percent_energy_usage_score')">
			</sct-charts>
			<sct-charts
				[type]="'BarChart'"
				[title]="'utilization.ah_return_score' | translate"
				[columnNames]="columnNames"
				[data]="ahChartData"
				[options]="barChartOptions"
				(select)="onBarSelect($event, rangesAh, ahReturnSelectedData, 'utilization.ah_return_score')">
			</sct-charts>
		</div>
	</div>
</div>


<ng-template #noDataToShow>
	<div class="alert alert-info m-4">{{'g.no_data_to_show' | translate}}</div>
</ng-template>

<app-modal #popupModal [hasConfirmButton]="false" [hasCloseButton]="false" [title]="modalTitle" size="lg">
	<sct-custom-table
		*ngIf="tableData.length"
		[columnsConfig]="columnConfig"
		[data]="tableData"
		[config]="tableConfig">
	</sct-custom-table>
</app-modal>
